import { render, staticRenderFns } from "./about.vue?vue&type=template&id=c5c0f4cc&scoped=true"
import script from "./about.vue?vue&type=script&lang=ts"
export * from "./about.vue?vue&type=script&lang=ts"
import style0 from "./about.vue?vue&type=style&index=0&id=c5c0f4cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c0f4cc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TopEvents: require('/home/runner/work/ballparkfantasia.com-web/ballparkfantasia.com-web/frontend/components/top/events.vue').default,CommonSectionTitle: require('/home/runner/work/ballparkfantasia.com-web/ballparkfantasia.com-web/frontend/components/common/section-title.vue').default,CommonCustomImage: require('/home/runner/work/ballparkfantasia.com-web/ballparkfantasia.com-web/frontend/components/common/custom-image.vue').default,TopVideos: require('/home/runner/work/ballparkfantasia.com-web/ballparkfantasia.com-web/frontend/components/top/videos/index.vue').default,TopMessage: require('/home/runner/work/ballparkfantasia.com-web/ballparkfantasia.com-web/frontend/components/top/message.vue').default,TopAccess: require('/home/runner/work/ballparkfantasia.com-web/ballparkfantasia.com-web/frontend/components/top/access.vue').default})
